import React from 'react'
import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import { loadAggregatedActivities, loadFlatActivities } from 'actions/activity'
import HomeActivityExtraNav from './HomeActivityExtraNav'
import { get_query } from 'lib/search_util'

import universal from 'react-universal-component'
const component = universal(props => import('./HomeActivityPage.js'))

class AsyncHomeActivityPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    let { navigation: { stack } } = getState()
    let search = get_query(stack)
    if (search) {
      try {
        await loadFlatActivities({ filter: search, limit: 50 })(
          dispatch,
          getState,
          opts
        )
      } catch (e) {
        log.error(e)
      }
      return
    }

    try {
      await loadAggregatedActivities({})(dispatch, getState, opts)
    } catch (e) {
      log.error(e)
    }
  }
  getExtraSecondaryNavigation() {
    return <HomeActivityExtraNav key={Date.now() + '_'} />
  }
}

export default new AsyncHomeActivityPage()
